// Configuración de API para desarrollo y producción
const API_CONFIG = {
  // En desarrollo, usa el proxy (localhost:3000 -> localhost:5000)
  development: {
    baseURL: '/api',
    timeout: 10000
  },
  // En producción, usa la ruta /heza-api/ según la configuración de Apache
  production: {
    baseURL: '/heza-api',
    timeout: 10000
  }
};

// Obtener la configuración según el entorno
const getApiConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return API_CONFIG[env];
};

// Función para construir URLs de API
export const buildApiUrl = (endpoint) => {
  const config = getApiConfig();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${config.baseURL}${cleanEndpoint}`;
};

// Función para hacer peticiones GET
export const apiGet = async (endpoint, options = {}) => {
  const url = buildApiUrl(endpoint);
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// Función para hacer peticiones POST
export const apiPost = async (endpoint, data = {}, options = {}) => {
  const url = buildApiUrl(endpoint);
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    body: JSON.stringify(data),
    ...options
  });
  
  if (!response.ok) {
    // Intentar leer el contenido de la respuesta para debugging
    const responseText = await response.text();
    console.error('Error response:', {
      status: response.status,
      statusText: response.statusText,
      url: url,
      content: responseText.substring(0, 500) // Primeros 500 caracteres
    });
    
    // Si la respuesta parece ser HTML, es un error de configuración del servidor
    if (responseText.trim().toLowerCase().startsWith('<!doctype') || 
        responseText.trim().toLowerCase().startsWith('<html')) {
      throw new Error(`Error de configuración del servidor: Se recibió HTML en lugar de JSON. URL: ${url}`);
    }
    
    throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
  }
  
  // Verificar que la respuesta sea JSON válido
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const responseText = await response.text();
    console.error('Non-JSON response:', responseText.substring(0, 500));
    throw new Error(`Respuesta no válida: Se esperaba JSON pero se recibió ${contentType}`);
  }
  
  return response.json();
};

// Función para hacer peticiones PUT
export const apiPut = async (endpoint, data = {}, options = {}) => {
  const url = buildApiUrl(endpoint);
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    body: JSON.stringify(data),
    ...options
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// Función para hacer peticiones DELETE
export const apiDelete = async (endpoint, options = {}) => {
  const url = buildApiUrl(endpoint);
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// Configuración para axios (si se usa)
export const axiosConfig = {
  baseURL: getApiConfig().baseURL,
  timeout: getApiConfig().timeout,
  headers: {
    'Content-Type': 'application/json'
  }
};

// Exportar la configuración actual para debugging
export const getCurrentApiConfig = () => {
  const config = getApiConfig();
  return {
    ...config,
    environment: process.env.NODE_ENV || 'development'
  };
}; 